import register from "./register";
import handle from "./handle";

export const appWindowRegister = register;
export const appWindowHandle = handle;

